import React from 'react';
import './loading.css';
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const Loading_items = () => {


  return (
    // <div  className="loding-body" > 
    // </div>
    <div className='container_size'>
      <div >
            <div className="loading-items"></div>
      </div>
    </div>

  );
};

export default Loading_items;
